<section class="content">
  <div class="content-block">

    @if (control != 'dashboard') {
      <div class="block-header">
        <app-breadcrumb
          [items]="[
        { label: 'DASHBOARD' }]">
        </app-breadcrumb>
      </div>
    } @else {
      <div class="block-header">
        <app-breadcrumb
          [items]="[
        { label: 'PACIENTES' }]">
        </app-breadcrumb>
      </div>
    }

    <app-top-widgets></app-top-widgets>

    <div class="row">
      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
        <div class="card">
          <div class="materialTableHeader">
            <div class="left">
              <ul class="header-buttons-left ms-0">
                <li class="tbl-search-box">
                  <label><i class="material-icons search-icon">search</i></label>
                  <input
                    data-tour="patient-search"
                    #filter
                    aria-autocomplete="none"
                    aria-label="Search box" autocomplete="nope" class="browser-default search-field"
                    placeholder="BUSCAR"
                    type="text">
                </li>
              </ul>
            </div>
            <div class="right">
              <ul class="tbl-export-btn">
                <li class="tbl-header-btn" *ngIf="isUserDoctor || isUserParticular">
                  <div class="m-l-10" matTooltip="CREAR">
                    <button (click)="addNew()" color="primary" mat-mini-fab data-tour="patient-create">
                      <mat-icon>add</mat-icon>
                    </button>
                  </div>
                </li>
                <li class="tbl-header-btn">
                  <div class="m-l-10" matTooltip="RECARGAR">
                    <button (click)="refresh()" color="primary" mat-mini-fab>
                      <mat-icon>refresh</mat-icon>
                    </button>
                  </div>
                </li>
                <li>
                  <div class="export-button m-l-10" matTooltip="EXCEL">
                    <img (click)="exportExcel()" alt="" height="512" ngSrc="assets/images/icons/xlsx.png" width="512"/>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div class="body overflow-auto">
            <div class="responsive_table">
              <table [dataSource]="dataSource" class="mat-cell advance-table" mat-table matSort>

                <ng-container matColumnDef="idPaciente">
                  <mat-header-cell *matHeaderCellDef mat-sort-header>Id</mat-header-cell>
                  <mat-cell *matCellDef="let row" matTooltip="{{row.idPaciente}}">{{ row.idPaciente }}</mat-cell>
                </ng-container>

                <ng-container matColumnDef="name">
                  <mat-header-cell *matHeaderCellDef mat-sort-header>NOMBRE</mat-header-cell>
                  <mat-cell (click)="goToProfile(row)" *matCellDef="let row" matTooltip="{{row.nombres}}" data-tour="patient-name-cell"><span
                    class="mobile-label">Nombres:</span>
                    <div class="block">
                      <span class="prop_one">{{ row.nombres }}</span>
                      @if (row.genero === 'M') {
                        <span class="badge badge-solid-blue">
                        {{ row.genero }}</span>
                      }
                      @if (row.genero === 'F') {
                        <span class="badge badge-solid-pink">
                        {{ row.genero }}</span>
                      }
                      <span class="prop_two">EDAD: {{ row.edad }} AÑOS</span>
                    </div>
                  </mat-cell>
                </ng-container>


                <ng-container matColumnDef="bDate">
                  <mat-header-cell *matHeaderCellDef mat-sort-header>FECHA DE NACIMIENTO</mat-header-cell>
                  <mat-cell *matCellDef="let row" matTooltip="{{row.fechaNacimiento}}">
                    <span class="mobile-label">Fecha de Nacimiento:</span> {{ row.fechaNacimiento }}
                  </mat-cell>
                </ng-container>

                <ng-container matColumnDef="email">
                  <mat-header-cell *matHeaderCellDef mat-sort-header>CORREO</mat-header-cell>
                  <mat-cell *matCellDef="let row" matTooltip="{{row.email}}">
                    <span class="mobile-label">Correo:</span>
                    <a href="mailto:{{row.email}}">{{ row.email }}</a>
                  </mat-cell>
                </ng-container>

                <ng-container matColumnDef="mobile">
                  <mat-header-cell *matHeaderCellDef mat-sort-header>TELEFONO</mat-header-cell>
                  <mat-cell *matCellDef="let row" [matTooltip]="row.movil | formatMobile">
                    {{ row.movil | formatMobile }}
                  </mat-cell>

                </ng-container>

                <ng-container matColumnDef="status">
                  <mat-header-cell *matHeaderCellDef mat-sort-header>ESTATUS</mat-header-cell>
                  <mat-cell *matCellDef="let row" matTooltip="{{row.status}}"><span class="mobile-label">Estatus:</span>
                    @if (row.status === 'Activo') {
                      <span class="badge badge-solid-green">
                        {{ row.status }}</span>
                    } @else {
                      <span class="badge badge-solid-red">
                        {{ row.status }}</span>
                    }
                  </mat-cell>
                </ng-container>

                <!-- ANTECEDENTES: se mantiene como esta -->
                <ng-container matColumnDef="antecedentes">
                  <mat-header-cell *matHeaderCellDef class="pr-0">ANTECEDENTES</mat-header-cell>
                  <mat-cell *matCellDef="let row; let i = index;" class="pr-0">
                    <span class="mobile-label">Antecedentes:</span>
                    <button
                      (click)="$event.stopPropagation(); showDiagnostics(row)"
                      [disabled]="
                                (!row.alergias || row.alergias.length === 0) &&
                                (!row.molecules || row.molecules.length === 0) &&
                                (!row.patologias || row.patologias.length === 0)"
                      class="tbl-fav-std"
                      mat-icon-button
                      matTooltip="Ver antecedentes">
                      <app-feather-icons [icon]="'file-text'"></app-feather-icons>
                    </button>
                  </mat-cell>
                </ng-container>

                <!-- ACCIONES: unifica editar, eliminar, recetar y evento -->
                <ng-container matColumnDef="acciones">
                  <mat-header-cell *matHeaderCellDef class="pr-0">ACCIONES</mat-header-cell>
                  <mat-cell *matCellDef="let row; let i=index;" class="pr-0">
                    <div class="acciones-container">

                      <div>
                        <button mat-icon-button matTooltip="Editar" (click)="$event.stopPropagation(); editCall(row)">
                          <mat-icon class="btn-edit">edit</mat-icon>
                        </button>
                      </div>

                      <div>
                        <button *ngIf="isUserAdmin" mat-icon-button matTooltip="Eliminar" (click)="$event.stopPropagation(); deleteItem(row)">
                          <mat-icon class="tbl-fav-delete">delete</mat-icon>
                        </button>
                      </div>

                      <div>
                        <button
                          mat-icon-button
                          matTooltip="Recetar"
                          (click)="$event.stopPropagation(); goToRecetar(row)">
                          <i class="fas fa-file-prescription btn-receta"></i>
                        </button>
                      </div>

                      <div *ngIf="isUserAdmin || isUserDoctor">
                        <button mat-icon-button matTooltip="Eventos" (click)="$event.stopPropagation(); viewHealthEvents(row)">
                          <mat-icon class="btn-download">event_note</mat-icon>
                        </button>
                      </div>

                      <div *ngIf="showHipFeatures">
                        <button
                          mat-icon-button
                          matTooltip="Descargar HIP"
                          [disabled]="hipLoadingPatientId === row.idPaciente"
                          (click)="$event.stopPropagation(); downloadHip(row)">
                          <mat-icon class="btn-hip" *ngIf="hipLoadingPatientId !== row.idPaciente">description</mat-icon>
                          <mat-progress-spinner
                            *ngIf="hipLoadingPatientId === row.idPaciente"
                            color="primary"
                            [diameter]="20"
                            mode="indeterminate">
                          </mat-progress-spinner>
                        </button>
                      </div>

                    </div>
                  </mat-cell>
                </ng-container>

                <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                <mat-row *matRowDef="let row; columns: displayedColumns;" matRipple>
                </mat-row>
              </table>
              <!-- Loading spinner -->
              @if (data?.isTblLoading) {
                <div class="tbl-spinner">
                  <mat-progress-spinner color="primary" [diameter]="40" mode="indeterminate">
                  </mat-progress-spinner>
                </div>
              }
              @if (!data?.isTblLoading) {
                <div class="no-results" [style.display]="dataSource.renderedData.length === 0 ? '' : 'none'">
                  SIN RESULTADOS
                </div>
              }
              <mat-paginator [length]="dataSource.filteredData.length" [pageIndex]="0"
                             [pageSizeOptions]="[5, 10, 25, 100]"
                             [pageSize]="10">
              </mat-paginator>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
